/**
 * 예매 관련 Write 작업 목차
 * 
 * - createReservation() - 예매 신청
 * - updateReservationStatus() - 예매 상태 변경
 * - confirmPayment() - 입금 확인
 * - deleteReservation() - 예매 삭제
 * - saveTicketForm() - 예매 폼 저장/업데이트
 */

import apiClient from "@/utils/api";

/**
 * 예매 신청
 * @param {Object} reservationData - 예매 데이터
 * @returns {Promise<string>} 생성된 예매 ID
 */
export async function createReservation(reservationData) {
  try {
    const response = await apiClient.post("/api/ticket", reservationData);
    return response.data.id;
  } catch (error) {
    console.error("예매 신청 오류:", error);
    throw error;
  }
}

/**
 * 예매 상태 변경
 * @param {string} reservationId - 예매 ID
 * @param {string} status - 새로운 상태 (pending, confirmed, cancelled)
 * @returns {Promise<void>}
 */
export async function updateReservationStatus(reservationId, status) {
  try {
    await apiClient.patch(`/api/ticket/${reservationId}/status`, { status });
  } catch (error) {
    console.error("예매 상태 변경 오류:", error);
    throw error;
  }
}

/**
 * 입금 확인
 * @param {string} reservationId - 예매 ID
 * @param {boolean} confirmed - 확인 여부
 * @returns {Promise<void>}
 */
export async function confirmPayment(reservationId, confirmed) {
  try {
    await apiClient.patch(`/api/ticket/${reservationId}/payment`, { confirmed });
  } catch (error) {
    console.error("입금 확인 오류:", error);
    throw error;
  }
}

/**
 * 예매 삭제
 * @param {string} reservationId - 예매 ID
 * @returns {Promise<void>}
 */
export async function deleteReservation(reservationId) {
  try {
    await apiClient.delete(`/api/ticket/${reservationId}`);
  } catch (error) {
    console.error("예매 삭제 오류:", error);
    throw error;
  }
}

/**
 * 예매 폼 정보 저장/업데이트
 * @param {string} liveId - 라이브 ID
 * @param {Object} formData - 폼 데이터
 * @returns {Promise<void>}
 */
export async function saveTicketForm(liveId, formData) {
  try {
    await apiClient.post(`/api/ticket/form/${liveId}`, formData);
  } catch (error) {
    console.error("예매 폼 저장 오류:", error);
    throw error;
  }
}
